// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import uuidv4 from 'uuid/v4';
import Immutable from 'immutable';
import ImportSourcesModalUploaderDropzone from './ImportSourcesModalUploaderDropzone';
// css
import '../../styles/components/sources/ImportSourcesModalUploader.scss';


class ImportSourcesModalUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      queuedFiles: Immutable.Map()
    };

    this.handleDropFile = this.handleDropFile.bind(this);
    this.makeHandleRemoveFile = this.makeHandleRemoveFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDropFile(acceptedFiles) {
    const mapping = acceptedFiles.reduce((acc, file) => {
      acc[uuidv4()] = file;
      return acc;
    }, {});

    this.setState({
      queuedFiles: this.state.queuedFiles.merge(mapping)
    });
  }

  handleSubmit() {
    this.props.onSubmit(this.state.queuedFiles.toJS());
  }

  makeHandleRemoveFile(uuid) {
    return () => {
      this.setState({ queuedFiles: this.state.queuedFiles.delete(uuid) });
    };
  }

  hasQueuedFiles() {
    return !!this.state.queuedFiles.size;
  }

  isImportDone() {
    const { importResults, importErrors } = this.props;
    return Object.values(importResults).length || importErrors.length;
  }

  renderDoneMessage() {
    const { importErrors } = this.props;

    if (!importErrors.length) {
      return (
        <p>Your file import is complete. Click Start to go through your data or use the Analytics tab to begin analyzing the results.</p>
      );
    }
  }

  renderButtons() {
    const { onClickCancel } = this.props;

    if (this.isImportDone()) {
      return (
        <div className='import-sources-modal-uploader__buttons'>
          {this.renderDoneMessage()}
          <Button
            onClick={onClickCancel}
            primary
            label='OK'
          />
        </div>
      );
    }

    return (
      <div className='import-sources-modal-uploader__buttons'>
        <Button
          onClick={onClickCancel}
          label='Cancel'
        />
        <Button
          disabled={!this.hasQueuedFiles()}
          primary
          label='Import'
          onClick={this.handleSubmit}
        />
      </div>
    );
  }

  render() {
    const {
      onClickDownloadTemplates,
      importResults,
      importErrors,
      importing
    } = this.props;

    const { queuedFiles } = this.state;

    return (
      <div className='import-sources-modal-uploader'>
        <h2>Import Template Files</h2>
        <p>Use template files as additional ways to collect data for analysis and to effectively communicate with customers. <a href='#' onClick={onClickDownloadTemplates}>Download them here</a> and import them below. The data will automatically populate into your DSA.</p>
        <ImportSourcesModalUploaderDropzone
          files={queuedFiles}
          onDropFile={this.handleDropFile}
          makeOnRemoveFile={this.makeHandleRemoveFile}
          importResults={importResults}
          importErrors={importErrors}
          importing={importing}
          allowUpload={!this.isImportDone()}
        />
        {this.renderButtons()}
      </div>
    );
  }
}

ImportSourcesModalUploader.propTypes = {
  onClickCancel: PropTypes.func.isRequired,
  onClickDownloadTemplates: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  importResults: PropTypes.object.isRequired,
  importErrors: PropTypes.array.isRequired,
  importing: PropTypes.bool.isRequired
};

export default ImportSourcesModalUploader;



// WEBPACK FOOTER //
// ./src/components/sources/ImportSourcesModalUploader.js